import OfferItem from './OfferItem';

export default OfferItem;
